import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap group">
              <span className="w-8 h-8 flex items-center justify-center text-xl">
                🍉
              </span>
              <span className="font-heading text-xl font-bold text-primary-600 group-hover:text-primary-700 transition-colors">
                吃瓜爆料
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/'
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
                <i className="ri-search-line text-foreground-600"></i>
              </button>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-lg text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-background-50 shadow-lg max-h-[calc(100vh-4rem)] overflow-y-auto">
            <div className="p-4 flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">首页</Link>
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 cursor-pointer">关于我们</Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}